import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import PourQui from './components/PourQui';
import Bicouche from './components/Bicouche';
import Process from './components/Process';
import Prix from './components/Prix';
import PourquoiNous from './components/PourquoiNous';
import Temoignage from './components/Temoignage';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Toit plat membrane', item: 'https://couvreur-levis.com/toit-plat-membrane-elastomere' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Installation de toit plat',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Installation et entretien de toit plat à Lévis. Membrane élastomère bicouche, garantie 15 ans.",
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'CAD',
    lowPrice: '3500',
    highPrice: '35000',
    offerCount: '4',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Combien de temps dure une membrane élastomère ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Une membrane élastomère bicouche de qualité dure entre 25 et 35 ans dans notre climat québécois. La durée dépend de la qualité de la soudure, de l'épaisseur de la membrane (3mm ou 4mm), et de l'entretien régulier des drains. Soprema et IKO offrent des garanties fabricant de 15 à 25 ans sur leurs membranes premium.",
      },
    },
    {
      '@type': 'Question',
      name: "Faut-il enlever l'ancienne membrane ou peut-on poser dessus ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Généralement, on recommande l'enlèvement complet pour inspecter le pontage et l'isolant sous-jacent. Si l'ancienne membrane est encore saine et adhérente, on peut parfois poser une nouvelle couche par-dessus (technique du surtoiture). On évalue ça lors de l'inspection gratuite.",
      },
    },
    {
      '@type': 'Question',
      name: 'Quelle est la pente minimum pour un toit plat ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Un toit plat n'est jamais réellement plat — il a une pente minimale de 2% (environ 1/4 pouce par pied) pour permettre l'écoulement de l'eau vers les drains. Si votre toit n'a pas cette pente, on peut la corriger avec des cales d'isolant lors de la réfection.",
      },
    },
    {
      '@type': 'Question',
      name: "Peut-on installer en hiver à Lévis ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "La membrane élastomère est plus permissive que le bardeau pour les températures froides, mais on évite de souder sous -5°C car l'adhérence est réduite. En hiver, on fait des réparations d'urgence et des inspections. Les réfections complètes sont planifiées d'avril à novembre.",
      },
    },
    {
      '@type': 'Question',
      name: "Quelle différence entre élastomère, TPO et EPDM ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "L'élastomère (bitumineuse modifiée) est le standard au Québec depuis 40 ans — résistante au gel, facile à réparer, et les couvreurs locaux la maîtrisent parfaitement. Le TPO (membrane plastique blanche) est plus récent et écologique, mais moins répandu ici. L'EPDM (caoutchouc) est utilisé sur les grands immeubles commerciaux. Pour un duplex ou triplex à Lévis, le bicouche élastomère soudé reste le meilleur rapport qualité-prix.",
      },
    },
  ],
};

export default function ToitPlatPage() {
  usePageSEO({
    title: 'Toit plat Lévis | Membrane élastomère | Pose et entretien',
    description: 'Installation de toit plat à Lévis. Membrane élastomère bicouche, garantie 15 ans. Soumission gratuite en 2h. 418-476-9950.',
    urlPath: '/toit-plat-membrane-elastomere',
    keywords: 'toit plat Lévis, membrane élastomère, toiture commerciale, étanchéité toit, couvreur',
    ogImage: '/og/og-toit-plat-membrane-elastomere.jpg',
    ogImageAlt: 'Toit plat et membrane élastomère à Lévis - Garantie 15 ans',
    jsonLdSchema: [breadcrumbSchema, serviceSchema, faqSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <PourQui />
        <Bicouche />
        <Process />
        <Prix />
        <PourquoiNous />
        <Temoignage />
        <FAQ />
        <QuoteForm />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}